import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';
// @ts-expect-error - amplify_outputs.json is generated by Amplify
import outputs from '../amplify_outputs.json';

// Configure Amplify - outputs file is generated by `npx ampx sandbox` or deployment
if (outputs.auth || outputs.data || outputs.storage) {
  Amplify.configure(outputs);
} else {
  console.warn('Amplify not configured. Run `npx ampx sandbox` to deploy the backend.');
}

const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 7,
  colors: {
    brand: [
      '#e6f0ff',
      '#cfe0ff',
      '#9fbfff',
      '#6f9eff',
      '#477fe6',
      '#2f6bd1',
      '#2059b8',
      '#17438f',
      '#102f63',
      '#0b1f2a',
    ],
    accent: [
      '#e3f5e8',
      '#c7ecd1',
      '#8fd9a8',
      '#57c67e',
      '#2daf58',
      '#1d9a46',
      '#13842a',
      '#106e24',
      '#0c581d',
      '#083f15',
    ],
  },
  fontFamily: 'Manrope, system-ui, -apple-system, Segoe UI, sans-serif',
  headings: {
    fontFamily: 'Playfair Display, Manrope, system-ui, -apple-system, Segoe UI, sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </React.StrictMode>
);
